/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function () {
  this.querySelector("[aria-controls='modal-size-chart']").addEventListener('click', function (e) {
    if (document.querySelector('.ks-chart-modal-link')){
      document.querySelector('.ks-chart-modal-link').click();
      e.preventDefault();
    }
  });
});

  var xModal = function () {
    document.querySelectorAll("[aria-controls='modal-size-chart']").forEach(function (element) {
      element.addEventListener('click', function (e) {
        var modal = document.querySelector('x-modal');
        if (modal) {
          e.preventDefault();
          modal.setAttribute('open', true);
          modal.style.display = 'block';
          modal.style.opacity = '1';
        }
      });
    });
  }

var collapsible = function () {
  document.querySelectorAll('.Collapsible__Button').forEach((button) => {
    button.addEventListener('click', function () {
      this.classList.contains('active') ? this.classList.add('active') : this.classList.remove('active');
      var inner = this.parentElement.querySelector('.Collapsible__Inner');
      if (!inner) return;

      if (inner.style.maxHeight) {
        inner.style.maxHeight = null;
      } else {
        inner.style.maxHeight = inner.scrollHeight + "px";
      }
    });
  });
};


collapsible();